import React, { useState, useEffect } from "react";
import {
  Card,
  Avatar,
  Descriptions,
  Typography,
  Button,
  Modal,
  Form,
  Input,
  notification,
  message,
  Spin,
  Radio,
  DatePicker,
  Upload,
} from "antd";
import {
  UserOutlined,
  MailOutlined,
  PhoneOutlined,
  IdcardOutlined,
  CalendarOutlined,
  SafetyCertificateOutlined,
  HomeOutlined,
  EditOutlined,
  SolutionOutlined,
  ClockCircleOutlined,
  UploadOutlined,
} from "@ant-design/icons";

import { getUserById } from "../../api/setting/Index";
import { updateUserProfile } from "../../api/setting/Profile"; 

import moment from "moment";
const { Title } = Typography;


const UserProfile = () => {
const sessiData = JSON.parse(sessionStorage.getItem("user"));
  const [user, setUser] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isLoadingProfile, setIsLoadingProfile] = useState(true);
  const [uploadFile, setUploadFile] = useState(null);

  const [form] = Form.useForm();

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    setIsLoadingProfile(true);
    try {
      const usersData = await getUserById(sessiData[0].user[0].userid);
      setIsLoadingProfile(false);
      setUser(usersData.data);
    } catch (error) {
      setIsLoadingProfile(false);
      message.error(`Failed to fetch users: ` + error);
    }
  };

  const showModal = () => {
    const rawDate = user.employeeDetails.emp_tanggal_lahir;
    const birthMoment = moment(rawDate, "YYYY-MM-DD", true);
    form.setFieldsValue({
      name: user.employeeDetails.emp_nama,
      username: user.usr_username,
      phone: user.employeeDetails.emp_no_telepon,
      email: user.employeeDetails.emp_email,
      address: user.employeeDetails.emp_alamat,
      gender: user.employeeDetails.emp_gender,
      birthDate: birthMoment.isValid() ? birthMoment : null,
    });

    setUploadFile(null);
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    form.resetFields();
    setUploadFile(null);
    setIsModalVisible(false);
  };

  const handleUploadChange = ({ file, fileList }) => {
    const latestFile = fileList[fileList.length - 1];

    if (!fileList.length || file.status === "removed") {
      setUploadFile(null);
    } else if (latestFile?.originFileObj) {
      setUploadFile(latestFile.originFileObj);
    } else {
      console.log("originFileObj masih undefined", latestFile);
    }
  };

  const handleSave = async (values) => {
    const { name, username, phone, email, address, gender, birthDate } = values;

    const formData = new FormData();
    formData.append("empNama", name);
    formData.append("empAlamat", address || "");
    formData.append(
      "empTanggalLahir",
      birthDate ? birthDate.format("YYYY-MM-DD") : ""
    );
    formData.append("empGender", gender);
    formData.append("empEmail", email);
    formData.append("empNoTelepon", phone);
    formData.append("userName", username);
    formData.append("empCreatedBy", sessiData[0].user[0].fullname);

    if (uploadFile) {
      formData.append("image", uploadFile);
    }

    try {
      await updateUserProfile(user.usr_id_employee, formData);

      notification.success({
        message: "Sukses",
        description: "Profil berhasil disimpan.",
      });

      await fetchUsers();

      setIsModalVisible(false);
      form.resetFields();
      setUploadFile(null);
    } catch (error) {
      notification.error({
        message: "Error",
        description: "Gagal menyimpan profil: " + error.message,
      });
    }
  };

  if (isLoadingProfile) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Spin size="large" tip="Memuat data..." />
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 700, margin: "40px auto" }}>
      <Card
        style={{ borderRadius: 10, boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}
        extra={
          <Button icon={<EditOutlined />} onClick={showModal}>
            Edit Profil
          </Button>
        }
      >
        <div
          style={{ display: "flex", alignItems: "center", marginBottom: 30 }}
        >
          <Avatar
            size={100}
            src={user.employeeDetails.emp_photo}
            icon={!user.employeeDetails.emp_photo && <UserOutlined />}
          />
          <div style={{ marginLeft: 24 }}>
            <Title level={3} style={{ margin: 0 }}>
              {user.employeeDetails.emp_nama}
            </Title>
            <span style={{ color: "gray" }}>
              username : {user.usr_username}
            </span>
          </div>
        </div>

        <Descriptions column={1} bordered>
          <Descriptions.Item
            label={
              <>
                <IdcardOutlined /> NIP
              </>
            }
          >
            {user.employeeDetails.emp_nip}
          </Descriptions.Item>
          <Descriptions.Item
            label={
              <>
                <PhoneOutlined /> Telepon
              </>
            }
          >
            {user.employeeDetails.emp_no_telepon}
          </Descriptions.Item>
          <Descriptions.Item
            label={
              <>
                <UserOutlined /> Jenis Kelamin
              </>
            }
          >
            {user.employeeDetails.emp_gender}
          </Descriptions.Item>
          <Descriptions.Item
            label={
              <>
                <MailOutlined /> Email
              </>
            }
          >
            {user.employeeDetails.emp_email}
          </Descriptions.Item>
          <Descriptions.Item
            label={
              <>
                <SolutionOutlined /> Jabatan
              </>
            }
          >
            {user.jabatanDetails.jbt_nama_jabatan}
          </Descriptions.Item>
          <Descriptions.Item
            label={
              <>
                <SafetyCertificateOutlined /> Hak Akses
              </>
            }
          >
            {user.roleDetails.rl_nama_role}
          </Descriptions.Item>
          <Descriptions.Item
            label={
              <>
                <HomeOutlined /> Alamat
              </>
            }
          >
            {user.employeeDetails.emp_alamat}
          </Descriptions.Item>
          <Descriptions.Item
            label={
              <>
                <CalendarOutlined /> Tanggal Lahir
              </>
            }
          >
            {new Date(
              user.employeeDetails.emp_tanggal_lahir
            ).toLocaleDateString("id-ID", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </Descriptions.Item>
          <Descriptions.Item
            label={
              <>
                <CalendarOutlined /> Tanggal Bergabung
              </>
            }
          >
            {new Date(
              user.employeeDetails.emp_tanggal_masuk
            ).toLocaleDateString("id-ID", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </Descriptions.Item>
          <Descriptions.Item
            label={
              <>
                <ClockCircleOutlined /> Lama Bekerja
              </>
            }
          >
            {(() => {
              const masuk = moment(user.employeeDetails.emp_tanggal_masuk);
              const sekarang = moment();
              const tahun = sekarang.diff(masuk, "years");
              const bulan = sekarang.diff(masuk.add(tahun, "years"), "months");
              return `${tahun} tahun ${bulan} bulan`;
            })()}
          </Descriptions.Item>
        </Descriptions>
      </Card>

      <Modal
        title="Edit Profil"
        open={isModalVisible}
        onCancel={handleCancel}
        onOk={() => form.submit()}
        okText="Simpan"
        cancelText="Batal"
      >
        <Form form={form} layout="vertical" onFinish={handleSave}>
          <Form.Item
            label="Nama Lengkap"
            name="name"
            rules={[{ required: true, message: "Nama Lengkap wajib diisi" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Nama Akun (username)"
            name="username"
            rules={[{ required: true, message: "Nama Akun wajib diisi" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Telepon"
            name="phone"
            rules={[{ required: true, message: "Telepon wajib diisi" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Email"
            name="email"
            rules={[
              { required: true, message: "Email wajib diisi" },
              { type: "email", message: "Format email tidak valid" },
            ]}
          >
            <Input type="email" />
          </Form.Item>
          <Form.Item
            label="Jenis Kelamin"
            name="gender"
            rules={[{ required: true, message: "Jenis kelamin wajib dipilih" }]}
          >
            <Radio.Group>
              <Radio value="Pria">Pria</Radio>
              <Radio value="Wanita">Wanita</Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item
            label="Tanggal Lahir"
            name="birthDate"
            rules={[{ required: true, message: "Tanggal lahir wajib diisi" }]}
          >
            <DatePicker
              format="YYYY-MM-DD"
              style={{ width: "100%" }}
              allowClear={false}
            />
          </Form.Item>

          <Form.Item label="Alamat" name="address">
            <Input.TextArea rows={2} />
          </Form.Item>

          <Form.Item label="Foto Profil">
            <Upload
              beforeUpload={(file) => {
                const isImage = file.type.startsWith("image/");
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isImage) {
                  message.error("Hanya file gambar yang diperbolehkan!");
                }
                if (!isLt2M) {
                  message.error("Ukuran gambar harus di bawah 2MB!");
                }
                return isImage && isLt2M ? false : Upload.LIST_IGNORE;
              }}
              maxCount={1}
              onRemove={() => setUploadFile(null)}
              onChange={handleUploadChange}
              accept="image/*"
              showUploadList={{ showPreviewIcon: false }}
            >
              <Button icon={<UploadOutlined />}>Pilih Foto</Button>
            </Upload>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default UserProfile;
